<script setup lang="ts">
interface Props {
  entityName?: string
  entityId?: number
}
const props = defineProps<Props>()
const { isLoggedIn, dashboardUrl } = useDashboardAware()
const entityUrl = computed<Maybe<string>>(() => {
  if (!isLoggedIn.value) {
    return null
  }
  if (!props.entityId || !props.entityName) {
    return null
  }

  return `${dashboardUrl.value}resources/${props.entityName}/${props.entityId}`
})
</script>

<template>
  <NuxtLink
    v-if="entityUrl"
    ref="nofollow"
    class="dashboard-link"
    :href="entityUrl"
    :target="LinkTarget.BLANK"
  >
    <slot>
      <div class="dashboard-link__button">
        <Icon
          class="dashboard-link__icon"
          name="fluent:edit-48-filled"
        />
      </div>
    </slot>
  </NuxtLink>
</template>

<style lang="scss" scoped>
.dashboard-link {
  &:hover &__button {
    @apply bg-dark;
  }
  &:hover &__icon {
    @apply text-white;
  }
  &__button {
    @apply bg-primary/60 px-2 py-1;
  }
  &__icon {
    @apply text-white/60;
  }
}
</style>
